import { commonSiteCoreKeys } from "../../helpers/constants/siteCoreKeys";
import { useNavigationSiteCore } from "../../hooks/useNavigationSiteCore";
import { BREAKPOINTS } from "../../styles/constants.style";

export const HeaderCompanyLogo = () => {
  const { fetchMediaListImage, commonARIALabel } = useNavigationSiteCore();

  const desktopLogo = fetchMediaListImage(
    commonSiteCoreKeys.commonHeaderKey,
    commonSiteCoreKeys.headerLogo,
    commonSiteCoreKeys.mediumImage,
  );

  const mobileLogo = fetchMediaListImage(
    commonSiteCoreKeys.commonHeaderKey,
    commonSiteCoreKeys.headerLogoMobile,
    commonSiteCoreKeys.smallImage,
  );

  return (
    <a
      href="/dashboard"
      className="icon-container"
      aria-label={commonARIALabel.goToDashboard}
    >
      <picture>
        {/* Desktop logo */}
        <source
          media={`(min-width: ${BREAKPOINTS.TABLET_PORTRAIT})`}
          srcSet={desktopLogo?.ImageUrl}
        />
        {/* Mobile logo */}
        <img
          src={mobileLogo?.ImageUrl}
          alt={mobileLogo?.AltText}
          loading="lazy"
          decoding="async"
          className="logo"
        />
      </picture>
    </a>
  );
};
